import { Routes, Route, Navigate } from "react-router-dom";
import DashboardLayout from "./layouts/DashboardLayout";
import { RequireAuth, RedirectIfAuth } from "./components/AuthGuard";
import ErrorBoundary from "./components/ErrorBoundary";
import FleetOverview from "./pages/FleetOverview";
import TenantManagement from "./pages/TenantManagement";
import TenantDetail from "./pages/TenantDetail";
import LearningDashboard from "./pages/LearningDashboard";
import { PlatformImprovementRecommendations } from "./pages/PlatformImprovementRecommendations";
import { InvestigationPromptsQueue } from "./pages/InvestigationPromptsQueue";
import DeploymentHealth from "./pages/DeploymentHealth";
import InferenceUsage from "./pages/InferenceUsage";
import AuditLog from "./pages/AuditLog";
import Notifications from "./pages/Notifications";
import Backups from "./pages/Backups";
import Versions from "./pages/Versions";
import WorkstreamDetail from "./pages/WorkstreamDetail";
import UsageAnalytics from "./pages/UsageAnalytics";
import LabProgram from "./pages/LabProgram";
import DevLoopOverview from "./pages/DevLoopOverview";
import Queue from "./pages/Queue";
import Releases from "./pages/Releases";
import ContextPacks from "./pages/ContextPacks";
import Waitlist from "./pages/Waitlist";
import EmailDashboard from "./pages/EmailDashboard";
import ActionCenter from "./pages/ActionCenter";
import LaunchReadiness from "./pages/LaunchReadiness";
import Login from "./pages/Login";
import NotFound from "./pages/NotFound";
import WaitlistLanding from "./pages/WaitlistLanding";
import Register from "./pages/Register";
import PublicInfoPage from "./pages/PublicInfoPage";

export default function App() {
  return (
    <Routes>
      {/* Public route — redirects to dashboard if already logged in */}
      <Route
        path="/login"
        element={
          <RedirectIfAuth>
            <Login />
          </RedirectIfAuth>
        }
      />
      <Route path="/" element={<WaitlistLanding />} />
      <Route path="/join" element={<WaitlistLanding />} />
      <Route path="/waitlist" element={<WaitlistLanding />} />
      <Route path="/register" element={<Register />} />
      <Route path="/privacy" element={<PublicInfoPage kind="privacy" />} />
      <Route path="/terms" element={<PublicInfoPage kind="terms" />} />
      <Route path="/contact" element={<PublicInfoPage kind="contact" />} />

      {/* All dashboard routes require authentication */}
      <Route
        element={
          <RequireAuth>
            <ErrorBoundary>
              <DashboardLayout />
            </ErrorBoundary>
          </RequireAuth>
        }
      >
        <Route path="/fleet" element={<FleetOverview />} />
        <Route path="/releases" element={<Releases />} />
        <Route path="/deployments" element={<Navigate to="/releases" replace />} />
        <Route path="/deployments/:id" element={<DeploymentHealth />} />
        <Route path="/tenants" element={<TenantManagement />} />
        <Route path="/tenants/:id" element={<TenantDetail />} />
        <Route path="/learning" element={<LearningDashboard />} />
        <Route path="/learning/recommendations" element={<PlatformImprovementRecommendations />} />
        <Route path="/learning/investigation-prompts" element={<InvestigationPromptsQueue />} />
        <Route path="/learning/optimization" element={<DevLoopOverview />} />
        <Route path="/learning/workstreams/:id" element={<WorkstreamDetail />} />
        <Route path="/queue" element={<Queue />} />
        <Route path="/inference" element={<InferenceUsage />} />
        <Route path="/usage" element={<UsageAnalytics />} />
        <Route path="/audit" element={<AuditLog />} />
        <Route path="/notifications" element={<Notifications />} />
        <Route path="/backups" element={<Backups />} />
        <Route path="/readiness" element={<LaunchReadiness />} />
        <Route path="/versions" element={<Versions />} />
        <Route path="/context-packs" element={<ContextPacks />} />
        <Route path="/dev-loop" element={<Navigate to="/learning/optimization" replace />} />
        {/* /dev-loop/:id route deleted 2026-05-11 along with the orphaned
            DevLoopDetail.tsx component (zero importers). The legacy
            /dev-loop redirect above is kept in case anyone bookmarked
            the URL before consolidation. */}
        <Route path="/waitlist/manage" element={<Waitlist />} />
        <Route path="/emails" element={<EmailDashboard />} />
        <Route path="/actions" element={<ActionCenter />} />
        <Route path="/labs" element={<LabProgram />} />
      </Route>

      {/* 404 for unmatched routes */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
